<template>
  <div class="login">
    <div class="login-container">
      <div class="login-container-imgbox">
        <img src="./login-form.png" alt="">
      </div>
      <div class="login-container-form">
        <div class="login-container-form-content">
          <div class="login-container-form-content-title">
            <img src="./logo.png">
            <span>开源情报数据采集系统</span>
          </div>
          <div class="login-container-form-content-box">
            <a-form-model
              :model="userform"
              :rules="userformRules"
              ref="userform"
              class="form"
            >
              <a-form-model-item prop="loginAccount">
                <a-input
                  v-model="userform.loginAccount"
                  size="large"
                  placeholder="用户名"
                  allow-clear
                >
                  <a-icon
                    slot="prefix"
                    type="user"
                    style="color: rgba(0, 0, 0, 0.7)"
                  />
                </a-input>
              </a-form-model-item>
              <a-form-model-item prop="password">
                <a-input
                  v-model="userform.password"
                  size="large"
                  type="password"
                  placeholder="密码"
                  allow-clear
                >
                  <a-icon
                    slot="prefix"
                    type="lock"
                    style="color: rgba(0, 0, 0, 0.7)"
                  />
                </a-input>
              </a-form-model-item>

              <a-form-model-item>
                <a-button
                  @click="handleSubmitUser"
                  size="large"
                  class="btn"
                  style="width: 100%;"
                  type="primary"
                  html-type="submit"
                >
                  登 录
                </a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import { userNameLoginApi } from '@/api/System/User'
import md5Util from '@/utils/md5.js'

export default {
  data() {
    return {
      userform: {
        loginAccount: '',
        password: ''
      },
      userformRules: {
        loginAccount: [{ required: true, message: '账号不可为空', trigger: 'blur' }],
        password: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    //账号密码登陆
    async userNameLogin() {
      var copyForm = JSON.parse(JSON.stringify(this.userform))
      copyForm['password'] = md5Util.encryptPassword(copyForm['password'])
      let res = await userNameLoginApi({ ...copyForm })

      let { code, msg, extra } = res
      if (code == 200) {
        this.$message.success('登录成功')
        this.handleAfterLogin(extra.user)
      } else {
        this.$message.error(msg)
      }
    },

    handleSubmitUser() {
      this.$refs['userform'].validate((valid) => {
        if (valid) {
          this.userNameLogin()
        } else {
          return false
        }
      })
    },

    handleAfterLogin(user) {
      let { token, secret } = user
      Cookie.set('token', token)
      Cookie.set('secret', secret)
      this.$store.commit('SET_USER_INFO', user)
      this.$router.push({ name: 'Layout' })
    }
  }
}
</script>

<style lang="less">
@designWidth: 1920;

// 默认设计稿的高度
@designHeight: 1080;

.px2vw(@name, @px) {
  @{name}: (@px / @designWidth) * 100vw;
}

.px2vh(@name, @px) {
  @{name}: (@px / @designHeight) * 100vh;
}

.px2font(@px) {
  font-size: (@px / @designWidth) * 100vw;
}

.login {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: url('./login-bg.png');
  background-size: 100% 100%;
  &-container {
    .px2vw(width,1069);
    .px2vw(height,615);
    .px2vw(margin-top,230);
    .px2vw(margin-left,401);
    position: relative;
    &-imgbox {
      position: absolute;
      .px2vw(left,2);
      top: 0;
      height: 100%;
      .px2vw(width,620);
      // background: url(../../assets/imgs/login.png) no-repeat center;
      // background-size: 103% 120%;
      z-index: 2;
      img {
        .px2vw(width,620);
        .px2vw(height,615);
        // .px2vw(margin-top,-8);
        border-radius: 10px;
      }
    }
    &-form {
      position: absolute;
      .px2vw(top,12);
      .px2vw(right,-25);
      .px2vw(width,610);
      .px2vw(height,591);
      background-color:#F4F4F4;
      border-radius: 10px;
      &-content {
        .px2vw(width,490);
        .px2vw(height,591);
        .px2vw(margin-left,120);
        &-title {
          .px2vw(margin-top,152);
          .px2vw(margin-right,28);
          .px2vw(height,34); 
          .px2vw(letter-spacing,3.6); 
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-family: 'HONORSansCN-Bold';
          .px2font(26);
          color:#3E85C5;
          img {
            .px2vw(width,34);
            .px2vw(margin-right,10);
            .px2vw(height,34);
          }
        }
        &-box {
          display: flex;
          justify-content: center;
          .px2vw(margin-top,60);
          .form {
            .px2vw(width,340);
            .px2vw(margin-right,28);
            .ant-input-affix-wrapper {
              .px2vw(height,40);
              display: flex;
              align-items: center;
              // .px2vw(margin-top,35);
              .ant-input {
                .px2vw(border-radius,40)!important;
                .px2font(16);
                .px2vw(padding-left,40);
                border: 0;
                background-color: #fff;
                box-shadow: 0 2px 3px rgba(0,0,0,0.05),
                  -3px 2px 6px rgba(0,0,0,0.05),
                  3px 2px 6px rgba(0,0,0,0.05);
              }
              .ant-input-prefix,.ant-input-suffix {
                .px2font(16);
              }
            }
            .ant-form-explain {
              .px2vw(margin-left,20) !important;
            }
            .btn {
              .px2vw(height,34);
              .px2vw(margin-top,35);
              .px2vw(border-radius,34)!important;
              border: 0;
              background-color:#3E85C5;
              box-shadow: 0 4px 5px rgba(0,0,0,0.3),
                        -5px 4px 8px rgba(0,0,0,0.3),
                        5px 4px 8px rgba(0,0,0,0.3);
            }
          }
        }
      }
    }
  }
}
</style>
